<template>
    <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-pt-5">
        <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-1/6 pr-3">
            <div class="h7 tw-w-full pb-2 tw-flex tw-justify-between">
                <span>FILTERS :</span>
                <v-btn class="lg_hidden" text @click="showCategories = !showCategories">
                    View filters
                    <v-icon>{{ showCategories ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </div>
            <div class="tw-flex tw-flex-wrap tw-justify-center lg:tw-flex-col">
                <v-chip v-for="(filter, index) in activeFilters" :key="index" close class="mb-1 mr-1" @click:close="removeFilter(filter.value)">
                    <div>{{ filter.value.label }}</div>
                    <template v-slot:close>
                        <v-icon>mdi-close</v-icon>
                    </template>
                </v-chip>
            </div>

            <v-btn v-if="filtersChanged" color="primary" small @click="applyFilters" class="tw-mt-4">
                <template v-if="!isLoading">
                    Apply filters
                </template>
                <template v-else>
                    <v-progress-circular indeterminate size="24"></v-progress-circular>
                </template>
            </v-btn>
            <v-btn v-if="filtersActive && !filtersChanged" color="secondary" small @click="clearFilters" class="tw-mt-4">
                <template>
                    Clear filters
                </template>
            </v-btn>

            <div class="tw-flex tw-flex-col lg:tw-flex-row tw-justify-center tw-items-stretch tw-w-full lg:tw-flex-col tw-mb-4" v-show="showCategories || windowWidth >= lgBreakpoint">
                <v-card
                    v-for="(category, index) in filterCategories"
                    :key="index"
                    elevation="0"
                    class="tw-w-full"
                    v-if="filterByRole(category.access)"
                >
                    <v-card-title class="text-h6">{{ category.name }}</v-card-title>
                    <v-card-text class="tw-flex tw-flex-row tw-flex-wrap tw-gap-2">
                            <v-checkbox
                                v-for="(option, optionIndex) in category.options"
                                multiple
                                :key="optionIndex"
                                :value="option.value"
                                :label="option.label"
                                v-model="tempCategorySelection[category.field]"
                                @change="updateActiveFilters(category, option)"
                                hide-details="auto"
                            ></v-checkbox>
                    </v-card-text>
                    <v-card-actions/>
                </v-card>
            </div>
        </div>

        <div class="tw-flex tw-flex-col tw-w-full">
            <div class="h7 tw-hidden lg:tw-flex tw-w-full pb-2 tw-border-b tw-border-dark-grey">What's New</div>
            <div class="tw-flex tw-mt-5 tw-pb-5 tw-border-b tw-border-dark-grey">
                <HomeNewsArticle
                    :flex-row="true"
                    :image="featuredEvent.image"
                    :title="featuredEvent.title"
                    :date="$root.smartDate(featuredEvent.date)"
                    :content="$root.sanitizeAndTruncateHTML(featuredEvent.content, 200)"
                    :link="route('news-and-events.show', featuredEvent.id)"
                />
            </div>
            <div v-if="Events.length > 0">
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-pt-5 tw-gap-x-8 tw-gap-y-24">
                    <HomeNewsArticle
                        v-for="event in Events"
                        :key="event.id"
                        :image="event.image"
                        :title="event.title"
                        :date="$root.smartDate(event.date)"
                        :content="$root.sanitizeAndTruncateHTML(event.content, 200)"
                        :link="route('news-and-events.show', event.id)"
                    />
                </div>
            </div>
            <div v-else>
                <div class="tw-p-4">No result found.</div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import HomeNewsArticle from "@/Pages/ExternalPages/components/HomeNewsArticle";

    export default {
        name: "NewsEventsIndex",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        props: {
            'events': {
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                // The constants we will rely on
                type: Object,
                required: true
            },
        },
        components: {
            HomeNewsArticle,
        },
        data() {
            return {
                featuredEvent: this.events?.shift() || null,
                Events: this.events || [],
                isFlexRow: false,
                showCategories: false,
                windowWidth: 0,
                lgBreakpoint: 1024,
                activeFilters: [],
                previousFilters: [],
                isLoading: false,
                tempCategorySelection: {},
                filterCategories: [
                    {
                        name: 'MEMBERS 667',
                        options: [
                            {label: this.constants.EVENT_MEMBERS667.MEMBERS667_NOTICES, value: this.constants.EVENT_MEMBERS667.MEMBERS667_NOTICES},
                            {label: this.constants.EVENT_MEMBERS667.MEMBERS667_MEMORIAM, value: this.constants.EVENT_MEMBERS667.MEMBERS667_MEMORIAM}
                        ],
                        field: 'members667',
                        selected: null,
                        access: 'ALL',
                    },
                    {
                        name: 'IATSE UPDATES',
                        options: [
                            {label: this.constants.EVENT_TARGETS.TARGET_INTERNATIONAL, value: this.constants.EVENT_TARGETS.TARGET_INTERNATIONAL},
                            {label: this.constants.EVENT_TARGETS.TARGET_LOCAL, value: this.constants.EVENT_TARGETS.TARGET_LOCAL},
                        ],
                        field: 'target',
                        selected: null,
                        access: 'ALL',
                    },
                    {
                        name: 'SEMINAR',
                        options: [
                            {label: this.constants.EVENT_SEMINAR.SEMINAR_ONLINE, value: this.constants.EVENT_SEMINAR.SEMINAR_ONLINE},
                            {label: this.constants.EVENT_SEMINAR.SEMINAR_GTA, value: this.constants.EVENT_SEMINAR.SEMINAR_GTA},
                            {label: this.constants.EVENT_SEMINAR.SEMINAR_OTTAWA, value: this.constants.EVENT_SEMINAR.SEMINAR_OTTAWA},
                            {label: this.constants.EVENT_SEMINAR.SEMINAR_NORTHEAST, value: this.constants.EVENT_SEMINAR.SEMINAR_NORTHEAST},
                            {label: this.constants.EVENT_SEMINAR.SEMINAR_ATLANTIC, value: this.constants.EVENT_SEMINAR.SEMINAR_ATLANTIC},
                            {label: 'NL', value: this.constants.EVENT_SEMINAR.SEMINAR_NFLD},
                        ],
                        field:'seminars_trainings',
                        selected: null,
                        access: 'ALL',
                    },
                    {
                        name: 'COMMITTEE',
                        options: [
                            {label: this.constants.EVENT_COMMITTEE.COMMITTEE_YOUNG_WORKERS, value: this.constants.EVENT_COMMITTEE.COMMITTEE_YOUNG_WORKERS},
                            {label: this.constants.EVENT_COMMITTEE.COMMITTEE_WOMENS, value: this.constants.EVENT_COMMITTEE.COMMITTEE_WOMENS},
                            {label: this.constants.EVENT_COMMITTEE.COMMITTEE_GREEN, value: this.constants.EVENT_COMMITTEE.COMMITTEE_GREEN},
                            {label: this.constants.EVENT_COMMITTEE.COMMITTEE_PRIDE, value: this.constants.EVENT_COMMITTEE.COMMITTEE_PRIDE},
                            {label: this.constants.EVENT_COMMITTEE.COMMITTEE_CORE, value: this.constants.EVENT_COMMITTEE.COMMITTEE_CORE},
                            {label: this.constants.EVENT_COMMITTEE.COMMITTEE_OTHER, value: this.constants.EVENT_COMMITTEE.COMMITTEE_OTHER},
                        ],
                        field: 'committees',
                        selected: null,
                        access: 'ALL',
                    },
                    {
                        name: 'AWARDS & FESTIVALS',
                        options: [
                            {label: this.constants.EVENT_AWARDS.AWARD_NOTICES, value: this.constants.EVENT_AWARDS.AWARD_NOTICES},
                            {label: this.constants.EVENT_AWARDS.AWARD_NOMINATIONS, value: this.constants.EVENT_AWARDS.AWARD_NOMINATIONS},
                            {label: this.constants.EVENT_AWARDS.AWARD_WINNERS, value: this.constants.EVENT_AWARDS.AWARD_WINNERS},
                        ],
                        field: 'awards_festivals',
                        selected: null,
                        access: 'ALL',
                    },
                    {
                        name: 'OUTREACH',
                        options: [
                            {label: this.constants.EVENT_OUTREACHS.OUTREACH_EVENTS, value: this.constants.EVENT_OUTREACHS.OUTREACH_EVENTS},
                            {label: this.constants.EVENT_OUTREACHS.OUTREACH_WORKSHOPS, value: this.constants.EVENT_OUTREACHS.OUTREACH_WORKSHOPS},
                        ],
                        field: 'outreach',
                        selected: null,
                        access: 'ALL',
                    },
                ],
            };
        },
        computed: {
            filtersChanged() {
                return JSON.stringify(this.activeFilters) !== JSON.stringify(this.previousFilters);
            },
            filtersActive() {
                return this.activeFilters.length > 0;
            }
        },
        methods: {
            filterByRole(access) {
                if( access === 'ALL' ){
                    return true
                }
                else if( access != '' && this.$root.getUserRole() === access ){
                    return true
                }
                else {
                    return false
                }
            },
            updateWidth() {
                this.windowWidth = window.innerWidth;
            },
            removeFilter(filter) {
                let exists_at = this.activeFilters.findIndex(activeFilter =>  activeFilter.value === filter)
                let exists_already = exists_at > -1
                if (exists_already) {
                    let category_name = this.activeFilters[exists_at]?.field
                    let category = this.filterCategories.find(filterCategory => filterCategory.field === category_name)
                    this.activeFilters.splice(exists_at, 1)
                    if (!!category) {
                        category.selected = null
                        this.tempCategorySelection[category_name] = this.tempCategorySelection[category_name].filter(category_value => category_value !== filter)
                    }
                }
                this.applyFilters()
            },
            updateActiveFilters(category, option) {
                let exists_at = this.activeFilters.findIndex(activeFilter => activeFilter.category === category.name && activeFilter.value === option)
                let exists_already = exists_at > -1

                if (!exists_already) {
                    this.activeFilters.push({
                        category: category.name,
                        value: option,
                        field: category.field
                    })
                } else {
                    this.activeFilters.splice(exists_at, 1)
                }
            },
            clearFilters() {
                this.activeFilters = [];
                this.filterCategories.forEach(category => {
                    category.selected = null;
                });
                this.tempCategorySelection = {}
                this.applyFilters()
            },
            applyFilters() {
                this.isLoading = true;
                let activeFiltersMapped = _.cloneDeep(this.activeFilters).map((filter) => {
                    filter.value = filter.value.value
                    return filter
                })
                axios.post(route('AjaxGetEvents'), { filters: activeFiltersMapped})
                    .then(response => {
                        this.Events = response.data;
                        this.showCategories = false;
                        this.previousFilters = [...this.activeFilters];
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            this.$root.snackbar.error(error)
                        }
                    })
            },
        },
        mounted() {
            this.updateWidth();
            window.addEventListener('resize', this.updateWidth);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateWidth);
        },
    }
</script>
<style scoped>
    ol li::marker {
       font-weight: 400;
    }
    li {
        font-weight: 300;
    }
    .text-h6 {
        font-size: 0.85rem !important;
        margin: 0;
        padding: 0;
        font-family: ABCFavorit !important;
    }
    .v-card__text {
        margin: 0 !important;
        padding: 0!important;
    }
    @screen lg {
        .lg_hidden {
            display: none;
        }
    }
</style>
